import classNames from "classnames";
import PropTypes from "prop-types";

export const ArrowUpDownIcon = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const arrowUpDownClassName = classNames("arrow-up-down-icon", {
		[className]: className?.length > 0,
	});

	return (
		<svg
			className={arrowUpDownClassName}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 15 15"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.3125 9.375C5.65769 9.375 5.9375 9.09519 5.9375 8.75V4.6875H6.875C7.12781 4.6875 7.35569 4.53522 7.45244 4.30167C7.54919 4.06813 7.49569 3.79931 7.31694 3.62056L5.75444 2.05806C5.51038 1.81398 5.11463 1.81398 4.87056 2.05806L3.30808 3.62056C3.12933 3.79931 3.07586 4.06813 3.17259 4.30167C3.26933 4.53522 3.49723 4.6875 3.75002 4.6875H4.6875V8.75C4.6875 9.09519 4.96731 9.375 5.3125 9.375Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.6875 5.625C9.34231 5.625 9.0625 5.90481 9.0625 6.25L9.0625 10.3125L8.125 10.3125C7.87219 10.3125 7.64431 10.4648 7.54756 10.6983C7.45081 10.9319 7.50431 11.2007 7.68306 11.3794L9.24556 12.9419C9.48962 13.186 9.88538 13.186 10.1294 12.9419L11.6919 11.3794C11.8707 11.2007 11.9241 10.9319 11.8274 10.6983C11.7307 10.4648 11.5028 10.3125 11.25 10.3125H10.3125L10.3125 6.25C10.3125 5.90481 10.0327 5.625 9.6875 5.625Z"
				fill={fill}
			/>
		</svg>
	);
};

ArrowUpDownIcon.propTypes = {
	fill: PropTypes.string,
	size: PropTypes.number,
};
